/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import RouterService from '@ember/routing/router-service';
import { dropTask } from 'ember-concurrency';
import { timeout } from 'ember-concurrency';
import AnalyticsService from 'cio/services/analytics';

interface AutogeneratedAttributeTooltipArgs {
  key: string;
}

const TOOLTIP_TRACK_DELAY = 1000;

export default class AutogeneratedAttributeTooltip extends Component<AutogeneratedAttributeTooltipArgs> {
  @service router!: RouterService;
  @service analytics!: AnalyticsService;

  handleTooltipMouseEnter = dropTask(async () => {
    try {
      await timeout(TOOLTIP_TRACK_DELAY);

      this.analytics.track('people', 'id_tooltip_hovered', { source: this.router.currentRouteName });
    } catch {}
  });

  @action
  handleTooltipMouseLeave() {
    this.handleTooltipMouseEnter.cancelAll();
  }
}
